import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { DropdownItem, Dropdown } from '@comparethemarketau/manor-dropdown';
import { Typography } from '@comparethemarketau/manor-typography';

import { connect } from 'react-redux';

import { StyledManorDropdown } from './styled_manor_dropdown';
import { excessStateMapping, excessDispatchMapping } from './filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    labelSubTitle: {
        color: theme.colors.grey700,
        fontSize: theme.fontSize.sm
    },
    defaultDropdown: {
        height: theme.spacing[48]
    }
}));

const _ExcessFilterDropdown = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const { stagedValue, stageChange, disabled, showFiltersUpdateButton, useDefaultManorDropdown } = props;
    const handleChange = (event, value, option) => {
        if (value === stagedValue) {
            return;
        }
        stageChange(value);
        showFiltersUpdateButton();
    };

    return (
        <div className={classNames('test-policyFilters-excess')} data-value={stagedValue}>
            {
                useDefaultManorDropdown
                    ? (
                        <Dropdown
                            id="filters-excess-dropdown"
                            key={`excess-filter-${stagedValue}`}
                            trackingLabel="Excess Filter"
                            label={(
                                <div>
                                    <Typography>Excess Amount</Typography>
                                    <Typography className={classes.labelSubTitle}>You can tailor your premium by varying your excess</Typography>
                                </div>
                            )}
                            data-testid="filters-excess-dropdown_manor-dropdown"
                            selectedValue={stagedValue}
                            handleChange={handleChange}
                            disabled={disabled}
                            tooltip={null}
                            className={classes.defaultDropdown}
                        >
                            {DropdownItems()}
                        </Dropdown>
                    )
                    : (
                        <StyledManorDropdown
                            id="filters-excess-dropdown"
                            key={`excess-filter-${stagedValue}`}
                            trackingLabel="Excess Filter"
                            label={'EXCESS'}
                            tooltip={{
                                trackingLabel: 'tooltip for excess filter',
                                body: 'You can tailor your premium by varying your excess.'
                            }}
                            variant="text"
                            data-testid="filters-excess-dropdown_manor-dropdown"
                            selectedValue={stagedValue}
                            handleChange={handleChange}
                            disabled={disabled}
                        >
                            {DropdownItems()}
                        </StyledManorDropdown>
                    )
            }
        </div>
    );
};

const DropdownItems = () => {
    return exceeAmountItems.map((excessAmount) => <DropdownItem key={excessAmount} value={excessAmount}>{`$${excessAmount}`}</DropdownItem>);
};

_ExcessFilterDropdown.propTypes = {
    stagedValue: PropTypes.string,
    stageChange: PropTypes.func,
    showFiltersUpdateButton: PropTypes.func,
    // if cover type === TPFT' or 'TPPD', then it was disabled.
    disabled: PropTypes.bool,
    /**
     * Different UI implement
     */
    useDefaultManorDropdown: PropTypes.bool
};

const ExcessFilterDropdown = connect(excessStateMapping, excessDispatchMapping)(_ExcessFilterDropdown);

export { ExcessFilterDropdown, exceeAmountItems };

const exceeAmountItems = [
    '500', '600', '700', '800', '900', '1000', '1100', '1200', '1300', '1400', '1500', '1600', '1700', '1800', '1900', '2000'
];
